
import React from "react";
import { MovieProviderContent } from "./MovieProviderContent";

export const MovieProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <MovieProviderContent>
      {children}
    </MovieProviderContent>
  );
};
